document.callOnReady(function () {
  $("#notes-list-textarea").on("keyup", function () {
    if ($("#notes-list-textarea").val().length == 0) {
      $("#notes-list-submit-button").attr("disabled", "disabled");
    } else {
      $("#notes-list-submit-button").removeAttr("disabled");
    }
  });
});
